{
  "rampsPresenter": {
    "title": "Vorfelder – {{fboName}}",
    "stats": {
      "totalRamps": "Vorfelder gesamt",
      "totalAircraft": "Flugzeuge gesamt"
    },
    "columns": {
      "rampName": "Vorfeldname",
      "currentAircraft": "Aktuelles Flugzeug",
      "actions": "Aktionen"
    },
    "tooltips": {
      "aircraftCount": "Anzahl Flugzeuge auf dem Vorfeld"
    },
    "emptyState": {
      "title": "Noch keine Vorfelder",
      "description": "Erstelle dein erstes Vorfeld, um Flugzeugparkplätze und Zeitpläne zu verwalten."
    },
    "rampRow": {
      "buttons": {
        "currentRamp": "Aktuelles Vorfeld",
        "rampSchedule": "Vorfeldplan",
        "editTenants": "Mieter bearb."
      }
    }
  }
}
